// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__24O-2","rootSmall":"AddTileButton_rootSmall__3VEAs"};